module.exports = __webpack_public_path__ + "static/media/icon-pending.bc406830.svg";